import type { VesselMessage } from '../../../../types/VesselMessage';
import { Box } from '../../../common/ui/Box';
import { AverageConsumptionSection } from '../../VesselDetailPage/AvarageConsumptionSection/AverageConsumptionSection';
import { VesselBudget } from '../../VesselDetailPage/Budget/VesselBudget';
import { VesselDetailsSection } from '../../VesselDetailPage/components/VesselDetailsSection';
import type { LubricationChartUpload } from '../../VesselDetailPage/hooks/useLubricationChartUpload';
import { RemainingOnBoard } from '../../VesselDetailPage/RemainingOnBoard/RemainingOnBoard';

interface VesselDetailPageOverviewContentProps {
    vessel: VesselMessage;
    lubricationChartUpload: LubricationChartUpload;
}

export const VesselDetailPageOverviewContent = ({
    vessel,
    lubricationChartUpload,
}: VesselDetailPageOverviewContentProps) => {
    return (
        <Box display="grid" gridTemplateColumns="auto 25%" gap={48}>
            <Box display="flex" flexDirection="column" gap={48}>
                <RemainingOnBoard vessel={vessel} />
                <AverageConsumptionSection vesselId={vessel.id} customerId={vessel.customerId} />
                <VesselBudget vessel={vessel} />
            </Box>

            <VesselDetailsSection vessel={vessel} lubricationChartUpload={lubricationChartUpload} />
        </Box>
    );
};
